import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Injector } from '@angular/core';
import { FacilityService } from 'src/app/core/services/facility.service';
import { ImportDeclarationService } from '../../services/import-declaration.service';
import { finalize } from 'rxjs/operators';
import { deepCopy, getDataScopeByPermission, getRoleScopeColumnMappings, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as xlsx from 'xlsx';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { ImportSourceType } from 'src/app/core/enums/import-source-type.enum';
import { LaasOption } from 'src/app/core/models/laas-option';
import { DeleteImportDeclarationDetailRequest } from 'src/app/core/models/transport-operation/delete-import-declaration-detail-request';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { noFullWidthValidator } from 'src/app/core/utils/validation-functions';
import { ImportDeclarationDetailResponse } from './dto/import-declaration-detail';
@Component({
  selector: 'laas-import-search',
  templateUrl: './import-search.component.html',
  styleUrls: ['./import-search.component.scss']
})
export class ImportSearchComponent extends SessionBaseComponent implements OnInit {
  readonly preferenceKey: string;
  readonly preferenceKey2: string;
  readonly permissionCode: string;

  currentLang: string = this.laasSetting.language;
  @ViewChild('declarationDate') declarationDate!: CalendarComponent;
  @ViewChild('creationDate') creationDate!: CalendarComponent;
  isLoadingImportDetail: boolean = false;
  isSearchFormOpen: boolean;
  searchForm!: FormGroup;
  copyForm!: FormGroup;
  importForm!: FormGroup;
  searchParams: any;
  defaultSearchParams: any;
  incoTermOptions: LaasOption[];
  incoTermList: any[];
  forwarderList: any[];
  vendorList: any[];
  exportCountryCodeList: any[];
  docTypeList: any[];
  importTypeList: any[];
  whStatusList: any[];
  orgIdList: any[];
  statusList: any[];
  currencyList: any[];
  cityList: any[];
  brandList: any[];
  sourceTypeList: any[];
  vendorOptions: any[];
  isLoading: boolean;
  importRows: any[];
  selectedImportRows: any[];
  columns: any[];
  importDeclarationNo: string;
  detailColumns: any[];
  isShowCopyImportModal: boolean;
  isShowImportModal: boolean;
  copyParams: any;
  importDetailParams: any;
  copySubmitted: boolean;
  importSubmitted: boolean;
  importEvent: any;
  isShowBillingViewerModal: boolean;
  bookingNoFile: any;
  bookingInfo: any;
  translateValue: any;

  @ViewChild(DataTableComponent) table!: DataTableComponent;

  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "importDeclarationNo",
    direction: -1
  };

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private dropdownOptionsService: DropdownOptionsService,
    private importDeclarationService: ImportDeclarationService,
    private commonDataService: CommonDataService,
    private facilityService: FacilityService,
    private datePipe: DatePipe
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.ImportSearch;
    this.preferenceKey2 = UserPreferenceConstants.ImportDetail;
    this.permissionCode = PermissionConstants.ViewImportDeclaration;
    this.isSearchFormOpen = true;
    this.incoTermOptions = [];
    this.incoTermList = [];
    this.forwarderList = [];
    this.vendorList = [];
    this.exportCountryCodeList = [];
    this.docTypeList = [];
    this.importTypeList = [];
    this.currencyList = [];
    this.orgIdList = [];
    this.importRows = [];
    this.selectedImportRows = [];
    this.statusList = [];
    this.whStatusList = [];
    this.cityList = [];
    this.sourceTypeList = [];
    this.brandList = [];
    this.vendorOptions = [];
    this.isLoading = false;
    this.importDeclarationNo = "";
    this.isShowCopyImportModal = false;
    this.isShowImportModal = false;
    this.copySubmitted = false;
    this.importSubmitted = false;
    this.isShowBillingViewerModal = false;

    this.columns = [
      { field: 'facility', header: 'ImportDeclaration.MainTable.Facility', sort: true },
      { field: 'importDeclarationNo', header: 'ImportDeclaration.MainTable.ImportNum', sort: true },
      { field: 'orgId', header: 'ImportDeclaration.MainTable.Company', sort: true },
      { field: 'status', header: 'ImportDeclaration.MainTable.CustomsStatus', sort: true },
      { field: 'currency', header: 'ImportDeclaration.MainTable.RFQCurrency', sort: true },
      { field: 'importRate', header: 'ImportDeclaration.MainTable.CustomsExchangeRate', sort: true },
      { field: 'importAmount', header: 'ImportDeclaration.MainTable.CustomsAmount', sort: true },
      { field: 'whNo', header: 'ImportDeclaration.MainTable.ReceiptFormNum', sort: true },
      { field: 'whStatus', header: 'ImportDeclaration.MainTable.ReceiptFormStatus', sort: true },
      { field: 'incoTerm', header: 'ImportDeclaration.MainTable.TradeTerm', sort: true },
      { field: 'forwarder', header: 'ImportDeclaration.MainTable.Forwarder', sort: true },
      { field: 'vendor', header: 'ImportDeclaration.MainTable.Supplier', sort: true },
      { field: 'exportCountryCode', header: 'ImportDeclaration.MainTable.ExportCountryCode', sort: true },
      { field: 'exportCityCode', header: 'ImportDeclaration.MainTable.ExportCity', sort: true },
      { field: 'apInvoiceId', header: 'ImportDeclaration.MainTable.PaymentApplicationNum', sort: true },
      { field: 'apglDt', header: 'ImportDeclaration.MainTable.APCreationDate', dataType: 'date', sort: true },
      { field: 'importAmountTax', header: 'ImportDeclaration.MainTable.CustomsDutyTax', sort: true },
      { field: 'importAcctdAmount', header: 'ImportDeclaration.MainTable.CustomsDeclarationAntAC', sort: true },
      { field: 'importAcctdAmountTax', header: 'ImportDeclaration.MainTable.CustomsDutyTaxAC', sort: true },
      { field: 'gvTaxNo', header: 'ImportDeclaration.MainTable.TaxBillNum', sort: true },
      { field: 'gvTaxDt', header: 'ImportDeclaration.MainTable.TaxBillDate', dataType: 'date', sort: true },
      { field: 'gvAcctdAmount', header: 'ImportDeclaration.MainTable.BusinessTaxBase', sort: true },
      { field: 'gvAcctdAmountTax', header: 'ImportDeclaration.MainTable.TaxAnt', sort: true },
      { field: 'gvAcctdExpBAmount', header: 'ImportDeclaration.MainTable.TradePromotionFee', sort: true },
      { field: 'gvAcctdExpCAmount', header: 'ImportDeclaration.MainTable.ImportDutyTax', sort: true },
      { field: 'gvAcctdExpDAmount', header: 'ImportDeclaration.MainTable.CargoDutyTax', sort: true },
      { field: 'docType', header: 'ImportDeclaration.MainTable.DeclarationType', sort: true },
      { field: 'docNo', header: 'ImportDeclaration.MainTable.IdentificaitonNum', sort: true },
      { field: 'importDt', header: 'ImportDeclaration.MainTable.DeclarationDate', dataType: 'date', sort: true },
      { field: 'importType', header: 'ImportDeclaration.MainTable.CustomsDeclarationMethod', sort: true },
      { field: 'expressBill', header: 'ImportDeclaration.MainTable.AWBNum', sort: true },
      { field: 'mawbNo', header: 'ImportDeclaration.MainTable.MAWB', sort: true },
      { field: 'reference', header: 'ImportDeclaration.MainTable.Remarks', sort: true },
      { field: 'applyNo', header: 'ImportDeclaration.MainTable.CaseNum', sort: true },
      { field: 'createDt', header: 'ImportDeclaration.MainTable.CreationDate', dataType: 'date', sort: true },
      { field: 'updateDt', header: 'ImportDeclaration.MainTable.UpdateDate', dataType: 'date', sort: true },
    ];

    this.detailColumns = [
      { field: '__delete', header: 'ImportDeclaration.SubTable.Delete', sort: false },
      { field: 'sourceType', header: 'ImportDeclaration.SubTable.DocumentSource', sort: true },
      { field: 'trxNumber', header: 'ImportDeclaration.SubTable.TrxNumber', sort: true },
      { field: 'status', header: 'ImportDeclaration.SubTable.DetailsStatus', sort: true },
      { field: 'trxDt', header: 'ImportDeclaration.SubTable.TrxDate', dataType: 'date', sort: true },
      { field: 'trxAmount', header: 'ImportDeclaration.SubTable.TrxAmount', sort: true },
      { field: 'importAccTdAmt', header: 'ImportDeclaration.SubTable.ImportAccTDAmt', sort: true },
      { field: 'brand', header: 'ImportDeclaration.SubTable.Brand', sort: true },
      { field: 'pcsrDept', header: 'ImportDeclaration.SubTable.PCSRDept', sort: true },
      { field: 'pcsrName', header: 'ImportDeclaration.SubTable.PCSRName', sort: true },
      { field: 'createDt', header: 'ImportDeclaration.SubTable.CreationTime', dataType: 'date', sort: true },
      { field: 'updateDt', header: 'ImportDeclaration.SubTable.EditTime', dataType: 'date', sort: true }
    ];

    this.searchParams = {
      importDeclarationNo: [],
      whNo: [],
      incoTerm: [],
      forwarder: [],
      vendor: null,
      exportCountryCode: [],
      docType: [],
      docNo: [],
      applyNo: [],
      importStartDtTmp: null,
      importEndDtTmp: null,
      importType: [],
      expressBill: [],
      mawbNo: [],
      orgId: [],
      status: [],
      createStartDateTmp: null,
      createEndDateTmp: null,
      createUser: [],
      updateUser: [],
      brand: [],
      trxNumber: [],
      facilityList: []
    }

    this.searchForm = this.fb.group({
      importDeclarationNo: [],
      whNo: [],
      incoTerm: [],
      forwarder: [],
      vendor: [],
      exportCountryCode: [],
      docType: [],
      docNo: [],
      applyNo: [],
      importStartDtTmp: null,
      importEndDtTmp: null,
      importType: [],
      expressBill: [],
      mawbNo: [],
      orgId: [],
      status: [],
      createStartDateTmp: null,
      createEndDateTmp: null,
      createUser: [],
      updateUser: [],
      brand: [],
      trxNumber: [],
      facilityList: []
    });

    this.copyParams = {
      importDeclarationNo: '',
      expressBill: '',
      importAmount: null,
      docNo1: null,
      docNo2: null,
      docNo3: null,
      docNo4: null,
      docNo5: null
    };

    this.copyForm = this.fb.group({
      expressBill: ['', Validators.required],
      importAmount: null,
      docNo1: ['', noFullWidthValidator()],
      docNo2: ['', noFullWidthValidator()],
      docNo3: ['', noFullWidthValidator()],
      docNo4: ['', noFullWidthValidator()],
      docNo5: ['', noFullWidthValidator()]
    });

    let today = new Date();

    this.importDetailParams = {
      importDeclarationNo: '',
      sourceType: "",
      trxNumber: [],
      trxDtTmp: `${today.getFullYear()}/${(today.getMonth() + 1)}/${today.getDate()}`,
      trxAmount: null,
      pcsrDept: "",
      brand: ""
    };

    this.importForm = this.fb.group({
      sourceType: ["", Validators.required],
      trxNumber: [[], Validators.required],
      trxDtTmp: [`${(new Date()).getFullYear()}/${((new Date()).getMonth() + 1)}/${(new Date()).getDate()}`, [this.sourceTypeValidate(["3", "5", "6", "7", "Z"]).bind(this.importDetailParams.sourceType)]],
      trxAmount: [null, [this.sourceTypeValidate(["3", "5", "6", "Z"]).bind(this.importDetailParams.sourceType)]],
      pcsrDept: [""],
      brand: ["", [this.sourceTypeValidate(["3", "7"]).bind(this.importDetailParams.sourceType)]]
    });
  }

  private sourceTypeValidate(reqiredArr: any[]) {
    return (control: FormControl) => {
      if (reqiredArr.includes(this.importDetailParams.sourceType) && isNullOrEmpty(control.value)) {
        return { required: true };
      }
      return null;
    }
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    const routeData = this.routeStateService.getCurrentAndConsume()?.data;
    if (!isNullOrEmpty(routeData)) {
      this.searchParams.importDeclarationNo = routeData.importDeclarationNo;
      this.searchBtnClick();
    }

    //forwarder Options
    this.facilityService.getForwarderOptions(this.laasSetting.facility).subscribe({
      next: result => {
        this.forwarderList = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    // vendor Options
    this.facilityService.getAllVendorOptions().subscribe({
      next: result => {
        this.vendorOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //country Code Options
    this.facilityService.getCountryOptions().subscribe({
      next: result => {
        this.exportCountryCodeList = [...result].map((x: any) => {
          return {
            label: `${x.countryCode}-${x.countryName}`,
            value: x.countryCode,
          };
        });
      }
    });

    //Org Id Options
    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "").subscribe({
      next: result => {
        this.orgIdList = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityReferenceCode}-${x.legalEntityOUName}(${x.legalEntityOUCode})`,
            value: x.legalEntityOUCode,
          };
        });
      }
    });

    //Status Options
    this.facilityService.getImportDeclarationStatusOptions(this.laasSetting.facility).subscribe({
      next: result => {
        this.statusList = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //incoTerm Options
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.incoTermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.dropdownOptionsService.getIncoTermOptions()
      .subscribe({
        next: (options: any[]) => {
          this.incoTermList = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    //docType Options
    this.facilityService.getImportDocTypeOptions().subscribe({
      next: result => {
        this.docTypeList = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //ImportType Options
    this.facilityService.getImportTypeOptions().subscribe({
      next: result => {
        this.importTypeList = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //Currency Options
    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyList = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //City Options
    this.facilityService.getCityOptions().subscribe({
      next: result => {
        this.cityList = [...result].map((x: any) => {
          return {
            label: `${x.name}-${x.enName}`,
            value: x.seqNo.toString(),
          };
        });
      }
    });

    //wh status options
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', "WhDocStatus")
      .subscribe({
        next: (models: any[]) => {
          this.whStatusList = models.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });

    //Source Type Options
    this.facilityService.getSourceTypeOptions().subscribe({
      next: result => {
        this.sourceTypeList = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //Brand Options
    this.facilityService.getBrandOptions(1).subscribe({
      next: result => {
        this.brandList = [...result].map(x => {
          return {
            label: x.brandCode,
            value: x.brandName
          }
        });
        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {
              this.brandList.unshift({
                label: msg,
                value: ""
              })
            }
          });

      }
    })

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    //  defaultFacility
    const defaultFacility = [this.laasSetting.facility];
    this.searchParams.facilityList = defaultFacility;
    this.defaultSearchParams = deepCopy(this.searchParams);
    this.searchForm.get('facilityList')!.setValue(defaultFacility);

  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.table.setCurrentPage(0);
    this.searchImportDeclaration();
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchImportDeclaration();
  }

  searchBtnClick(): void {
    this.isSearchFormOpen = false;
    this.selectedImportRows.length = 0;
    this.pageInfo.pageIndex = 0;
    this.table.setCurrentPage(0);
    this.searchImportDeclaration();
  }

  searchImportDeclaration(): void {
    console.log('params: ' + JSON.stringify(this.searchParams));
    this.isLoading = true;

    this.searchParams.importStartDt = isNullOrEmpty(this.searchParams.importStartDtTmp) ? null : new Date(this.searchParams.importStartDtTmp).toISOString();
    this.searchParams.importEndDt = isNullOrEmpty(this.searchParams.importEndDtTmp) ? null : new Date(this.searchParams.importEndDtTmp).toISOString();
    this.searchParams.createStartDate = isNullOrEmpty(this.searchParams.createStartDateTmp) ? null : new Date(this.searchParams.createStartDateTmp).toISOString();
    this.searchParams.createEndDate = isNullOrEmpty(this.searchParams.createEndDateTmp) ? null : new Date(this.searchParams.createEndDateTmp).toISOString();

    const params = deepCopy(this.searchParams);
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    params.roleScopeColumnMappings = getRoleScopeColumnMappings(this.userProfile, this.permissionCode);
    params.pageIndex = this.pageInfo.pageIndex;
    params.pageSize = this.pageInfo.pageSize;
    params.sortOrder = this.sortOrder;

    this.importDeclarationService.getImportHeader(params)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.isSearchFormOpen = false;
      }))
      .subscribe({
        next: response => {
          this.importRows = response.content;
          // Change page Info
          this.pageInfo.totalRecords = response.totalElements;
          this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
          this.table.setPageInfo(this.pageInfo.totalRecords);
        },
        error: (err: HttpErrorResponse) => {
          this.pageInfo.totalRecords = 0;
          this.pageInfo.totalPages = 0;
          this.table.setPageInfo(this.pageInfo.totalRecords);
          this.toastErrorMessage(err.error);
        },
      });
  }

  resetClickBtn(event: any): void {
    this.declarationDate.ngOnInit();
    this.creationDate.ngOnInit();
    this.searchParams = deepCopy(this.defaultSearchParams);
    this.searchForm.reset({facilityList: this.defaultSearchParams.facilityList});
    this.searchParams.importStartDtTmp = null;
    this.searchParams.importEndDtTmp = null;
    this.searchParams.createStartDateTmp = null;
    this.searchParams.createEndDateTmp = null;
  }

  searchDetailClick(event: any): void {
    const rowData = event.rowData;
    const isClosed = event.expanded;

    if (isClosed) {
      return;
    }

    this.importDeclarationNo = rowData.importDeclarationNo;

    this.importDeclarationService.getImportDetail(this.importDeclarationNo).subscribe({
      next: result => {
        rowData.importDetails = [...result];
      },
      error: err => {

      },
      complete: () => {

      }
    })
  }

  importDetailBtnClick(event: any): void {
    this.loader.show();
    this.isLoadingImportDetail = true;

    this.importSubmitted = true;

    if (this.importForm.invalid) {
      this.toastService.warn(this.translateService.instant('ImportDeclareSearch.Alert.CheckrequiredFields'));
      this.loader.hide();
      return;
    }


    this.importDetailParams.trxDt = isNullOrEmpty(this.importDetailParams.trxDtTmp) ? null : new Date(this.importDetailParams.trxDtTmp).toISOString();
    this.importDetailParams.userId = this.userProfile.loginAccount;
    console.log('params: ' + JSON.stringify(this.importDetailParams));

    this.importDeclarationService.importDetail(this.importDetailParams)
    .pipe(finalize(() => {
      this.isLoadingImportDetail = false;
    }))
    .subscribe({
      next: (result: ImportDeclarationDetailResponse) => {
        this.isShowImportModal = false;
        this.searchDetailClick(this.importEvent);

        if(result.successfulDeclarationDetails?.length > 0){
          let declarationDetailsMessage = ``;
          let index = 1;
          result.successfulDeclarationDetails.forEach((x: any) => {
          declarationDetailsMessage += `${index}. ${x.trxNumber}\n`;
          index++;
          });
          this.translateService.get('ImportDeclarationImport.Success', { numberOfSuccess: result.successfulDeclarationDetails.length, importData: declarationDetailsMessage }).subscribe((translatedText: string) => {
          this.toastService.success(translatedText);
          });
        }

        if(result.failedResult?.failedTxnNumbers.length > 0){
          this.toastService.error(result.failedResult?.errorMessage);
        }
      },
      error: err => {
        this.loader.hide();
        if (!isNullOrEmpty(err.error.errorMsg)) {
          this.toastErrorMessage(err.error.errorMsg);
          return;
        }
        this.toastErrorMessage(err.error);
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  closeImportDetailModal(event: any): void {
    this.isShowImportModal = false;
  }

  openBillingViewerBtn(event: any, rowData: any): void {
    this.isShowBillingViewerModal = true;
    // this.bookingNoFile = '01BA2107090002';
    this.bookingNoFile = rowData.importDeclarationNo;
    this.bookingInfo = rowData;
  }

  openBillingFeeBtn(event: any, rowData: any): void {
    this.importDeclarationService.saveBillingBy(rowData.importDeclarationNo)
    .subscribe({
      next: result => {
        this.toastService.success('完成');
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  closeBilling(event: any): void {
    this.isShowBillingViewerModal = false;
  }

  changeSourceType(event: any): void {
    this.importSubmitted = false;
    let today = new Date();
    this.importForm.controls.trxDtTmp.setValue(`${today.getFullYear()}/${(today.getMonth() + 1)}/${today.getDate()}`);
    this.importForm.controls.trxAmount.setValue("");
    this.importForm.controls.brand.setValue("");
    this.importForm.controls.trxNumber.setValue([]);
    this.importDetailParams.trxNumber = [];

    if(this.importDetailParams.sourceType == ImportSourceType.FREIGHT || this.importDetailParams.sourceType == ImportSourceType.SAMPLE){
      this.loader.show();
      this.importDeclarationService.trxNumberForDetail(this.importDetailParams.importDeclarationNo).subscribe({
        next: (reuslt: any) => {
          this.importForm.controls.trxNumber.setValue([reuslt.trxNumber]);
          this.importDetailParams.trxNumber = [reuslt.trxNumber];
          if(this.importDetailParams.sourceType == ImportSourceType.SAMPLE){
            this.importForm.controls.pcsrDept.setValue("0000000000");
          }
        },
        complete: () => {
          this.loader.hide();
        }
      });
    }

  }

  openCopyImportDeclarationModal(event: any, rowData: any): void {
    this.copyForm.reset();
    this.copyParams.importDeclarationNo = rowData.importDeclarationNo;
    this.isShowCopyImportModal = true;
  }

  closeCopyImportDeclarationModal(event: any): void {
    this.copyForm.reset();
    this.isShowCopyImportModal = false;
  }

  openImportDetailDeclarationModal(event: any, rowData: any): void {
    this.importForm.reset();
    this.importDetailParams.importDeclarationNo = rowData.importDeclarationNo;
    let today = new Date();
    this.importForm.controls.trxDtTmp.setValue(`${today.getFullYear()}/${(today.getMonth() + 1)}/${today.getDate()}`);
    this.isShowImportModal = true;
    this.importSubmitted = false;
    this.importEvent = {
      rowData: rowData,
      expanded: false
    };
  }

  copyImportBtnClick(event: any): void {
    this.copySubmitted = true;

    if (this.copyForm.invalid) {
      this.toastService.warn(this.translateService.instant('ImportDeclareSearch.Alert.CheckrequiredFields'));
      return;
    }

    this.importDeclarationService.copyImportDeclaration(this.copyParams).subscribe({
      next: result => {
        console.log(result);
        this.searchForm.controls.importDeclarationNo.setValue([result.importDeclarationNo]);
        this.searchBtnClick();
        this.isShowCopyImportModal = false;
        this.copySubmitted = false;
      },
      error: err => {
        this.toastErrorMessage(err.error);
      },
      complete: () => {
      }
    });
  }

  formatTableTitle(importDeclaration: any): string {
    this.translateService.get('ImportDeclaration.SubTable.ImportDeclarationDetails')
      .subscribe({
        next: msg => {
          this.translateValue = msg
        }
      });
    return `${this.translateValue} (${importDeclaration.importDeclarationNo})`;
  }

  getTotalAmount(importMain: any): any {
  const validDetails = (importMain.importDetails ?? []).filter((x: any) => x.status !== 'C');

  if (validDetails.length === 0) {
    return {
      trxAmount: "",
      importAccTdAmt: ""
    };
  }

  const trxAmount = validDetails
    .map((x: any) => x.trxAmount ?? 0)
    .reduce((sum: number, x: number) => sum + x, 0);

  const importAccTdAmt = validDetails
    .map((x: any) => x.importAccTdAmt ?? 0)
    .reduce((sum: number, x: number) => sum + x, 0);

  return {
    trxAmount,
    importAccTdAmt
  };
}

  getVendorList(event: any): void {
    const key: string = event.filter;

    if (key != null && key.length > 0) {
      this.dropdownOptionsService.getVendorOptions(key).subscribe({
        next: result => {
          this.vendorList = [...result].map((x: any) => {
            return {
              label: x.optionDesc,
              value: x.optionCode,
            };
          });
          this.translateService.get('Common.Message.ChooseOption')
            .subscribe({
              next: msg => {
                this.vendorList.unshift({
                  label: msg,
                  value: ""
                });
              }
            });

        }
      });
    }
  }

  getVendorListByKey(key: any): any {
    if (key != null && key.length > 0) {
      this.dropdownOptionsService.getVendorOptions(key).subscribe({
        next: result => {
          return [...result].map((x: any) => {
            return {
              label: x.optionDesc,
              value: x.optionCode,
            };
          });
        }
      });
    }
  }

  // convenience getter for easy access to form fields
  f(fg: FormGroup): any { return fg.controls; }

  importDeclarationNoLinkClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo('/TransportOperation/ImportHeaderDetail', rowData, true);
  }

  confirmImportDeclarationBtnClick(event: any, rowData: any): void {
    this.loader.show();

    var confirmParam = {
      importDeclarationNo: rowData.importDeclarationNo
    };

    this.importDeclarationService.confirmImportDeclaration(confirmParam).subscribe({
      next: result => {
        if (result.flag == "S") {
          this.toastService.success(this.translateService.instant('ImportDeclareSearch.Success.ConfirmSuccess'));
          rowData.status = "B";
          this.searchDetailClick({
            rowData: rowData,
            expanded: false
          });
        } else {
          this.toastService.error(result.message);
        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    })
  }

  cancelImportDeclarationBtnClick(event: any, rowData: any): void {
    this.loader.show();

    var cancelParam = {
      importDeclarationNo: rowData.importDeclarationNo
    };

    this.importDeclarationService.cancelImportDeclaration(cancelParam).subscribe({
      next: result => {
        if (result.qfunction_com.length > 0) {
          var erpResult = result.qfunction_com[0].l_out;
          if (erpResult === "0") {
            this.toastService.success(this.translateService.instant('ImportDeclareSearch.Success.CancelSuccess'));
            rowData.status = "A";
            this.searchDetailClick({
              rowData: rowData,
              expanded: false
            });
          } else if (erpResult === "1") {
            this.toastService.error(this.translateService.instant('ImportDeclareSearch.Alert.ImportDeclarationPaid'));
          }
        } else {
          this.toastService.error(this.translateService.instant('ImportDeclareSearch.Alert.ERPReturnedError'));
        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    })
  }

  displayADImportWidget(column: string): boolean {
    var specialColumn = ["pcsrDept", "brand"];
    var displayElements = ["3", "5", "6", "7", "Z", "31"];
    if(specialColumn.includes(column)){
      displayElements = ["3", "5", "6", "7", "Z"];
    }
    return displayElements.includes(this.importDetailParams.sourceType);
  }

  deleteBtnClick(event: any, rowIndex: any, rowData: any): void {
    this.confirmationService.confirm({
      target: event.target,
      message: this.translateService.instant('ImportDeclareSearch.Confirm.ConfirmDelete'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteImportDeclarationDetail(this.importRows[rowIndex], rowData);
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  deleteImportDeclarationDetail(details: any, rowData: any): void {
    const deleteObj: DeleteImportDeclarationDetailRequest = {
      importDeclarationNo: details.importDeclarationNo,
      adNo: rowData.trxNumber,
      updateUser: this.userProfile.userName,
    };
    this.importDeclarationService.deleteImportDeclarationDetail(deleteObj)
      .subscribe({
        next: result => {
          this.toastService.success(this.translateService.instant('ImportDeclareSearch.Success.DeleteSuccess'));
          rowData.status = 'C';
          if (details.importDetails.every((x: any) => x.status === 'C')) {
            details.status = 'C';
            details.whStatus = 'C';
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  /**
   * Export to excel.
   * @param event p-button click event
   */
  async exportExcel(event: any): Promise<void> {
    const dataRows = [];
    const fieldRow: any = {};
    for (const column of this.columns) {
      fieldRow[column.header] = column.field;
    }
    dataRows.push(fieldRow);

    for (const item of this.selectedImportRows) {
      const row = {} as any;
      for (const column of this.columns) {
        if (item.hasOwnProperty(column.field)) {
          let value = item[column.field];
          switch (column.field) {
            case 'orgId':
              value = this.orgIdList.find(x => x.value === value)?.label;
              break;
            case 'status':
              value = this.statusList.find(x => x.value === value)?.label;
              break;
            case 'incoTerm':
              value = this.incoTermList.find(x => x.value === value)?.label;
              break;
            case 'forwarder':
              value = this.forwarderList.find(x => x.value === value)?.label;
              break;
            case 'exportCountryCode':
              value = this.exportCountryCodeList.find(x => x.value === value)?.label;
              break;
            case 'docType':
              value = this.docTypeList.find(x => x.value === value)?.label;
              break;
            case 'currency':
              value = this.currencyList.find(x => x.value === value)?.label;
              break;
            case 'exportCityCode':
              value = this.cityList.find(x => x.value === value)?.label;
              break;
            case 'importType':
              value = this.importTypeList.find(x => x.value === value)?.label;
              break;
            case 'whStatus':
              value = this.whStatusList.find(x => x.value === value)?.label;
              break;
            default:
              switch (column.dataType) {
                case 'date':
                  value = this.datePipe.transform(value, 'yyyy-MM-dd HH:mm:ss', this.laasSetting.facilityTimeZone);
                  break;
                default:
                  break;
              }
              break;
          }
          row[column.header] = value;
        }
      }
      dataRows.push(row);
    }

    const worksheet = xlsx.utils.json_to_sheet(dataRows);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob(
      [excelBuffer],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );
    const url = URL.createObjectURL(data);
    const linkEle = document.createElement('a');
    linkEle.href = url;
    linkEle.download = 'Import Declaration Result';
    linkEle.click();
    URL.revokeObjectURL(url);
    linkEle.remove();
  }

  onTrxNumberAdd(event: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value
      .split(/[\r\n,]+/)
      .map(x => x.trim())
      .filter(x => !isNullOrEmpty(x));

    let currentValues: string[] = this.importForm.controls.trxNumber.value || [];
    currentValues = currentValues.filter(item => !parsedValues.some(parsed => parsed == item || item.includes(parsed)));
    const combined = Array.from(new Set([...currentValues, ...parsedValues]));

    this.importForm.controls.trxNumber.setValue(combined);
    this.importDetailParams.trxNumber = combined;
  }

  onTrxNumberRemove(): void {
    const currentValues: string[] = this.importForm.controls.trxNumber.value || [];
    this.importDetailParams.trxNumber = currentValues;
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  dateOnChange(date: any,type:string) {
    switch(type){
      case "declarationDate" :
        this.searchParams.importStartDtTmp = date.startDate;
        this.searchParams.importEndDtTmp = date.endDate;
        break;
      case "creationDate" :
        this.searchParams.createStartDateTmp = date.startDate;
        this.searchParams.createEndDateTmp = date.endDate;
        break;
    }
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'facilityList':
        this.searchParams.facilityList = data;
        break;
    }
  }
}
